// Optional: ensure details/summary styling (native HTML accordion works without JS)
